var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#C7CDDD",
  d: "M14 11.5V7h14v18H14v-4.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C7CDDD",
  strokeWidth: 2,
  d: "m10 11-5 5 5 5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CDDD",
  d: "M5 15h14v2H5z"
})));
export { SvgIcLogout as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDExLjVWN0gyOFYyMS42MjVWMjVIMTRWMjAuNSIgc3Ryb2tlPSIjQzdDREREIi8+CjxwYXRoIGQ9Ik0xMCAxMUw1IDE2TDEwIDIxIiBzdHJva2U9IiNDN0NEREQiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSI1IiB5PSIxNSIgd2lkdGg9IjE0IiBoZWlnaHQ9IjIiIGZpbGw9IiNDN0NEREQiLz4KPC9zdmc+Cg==";